export default {
    dependencies: ['$element', 'radio'],
    callable(ele, radio) {
        if (document.querySelector('[data-no-ads-at-all]')) {
            return false;
        }
        const statustypeInputs = ele.querySelectorAll(
            "input[name='statustype']"
        );
        const adtypeInputs = ele.querySelectorAll("input[name='adtypes']");
        const adtypeLabels = ele.querySelectorAll('[data-adtypes-label-value]');

        radio('on-counters-calculated').subscribe(onCountersCalculated);
        init();

        function init() {
            if (ele.querySelector('#activeAds')) {
                ele.querySelector('#activeAds').click(); // avoid BFCache
            }
            if (ele.querySelector("input[id='all']")) {
                ele.querySelector("input[id='all']").click(); // avoid BFCache
            }
            setEvents();
        }

        function setEvents() {
            if (adtypeInputs.length > 0) {
                Array.from(adtypeInputs).forEach(item => {
                    item.addEventListener('click', evt => {
                        const el = evt.target;
                        const adtypevalue = el.value;
                        const statusvalue = document.querySelector(
                            "input[name='statustype']:checked"
                        ).value;
                        radio('on-filter-changed').broadcast(
                            adtypevalue,
                            statusvalue,
                            false
                        );
                    });
                });
            }

            if (statustypeInputs.length > 0) {
                Array.from(statustypeInputs).forEach(item => {
                    item.addEventListener('click', () => {
                        const adtypeEl = Array.from(adtypeInputs).filter(
                            input => input.checked
                        );
                        const adtypevalue =
                            adtypeEl.length > 0 ? adtypeEl[0].value : '';
                        const statusEl = Array.from(statustypeInputs).filter(
                            input => input.checked
                        );
                        const statusvalue =
                            statusEl.length > 0
                                ? statusEl[0].getAttribute('value')
                                : '';
                        if (statusvalue !== '' && adtypevalue !== '') {
                            radio('on-filter-changed').broadcast(
                                adtypevalue,
                                statusvalue
                            );
                        }
                    });
                });
            }
        }

        function onCountersCalculated(adtypeCounters) {
            if (!adtypeCounters) {
                return false;
            }
            let allCount = 0;
            Array.from(adtypeLabels).forEach(label => {
                for (const val in adtypeCounters) {
                    if (adtypeCounters.hasOwnProperty(val)) {
                        const labelVal = label.getAttribute(
                            'data-adtypes-label-value'
                        );
                        if (labelVal === val) {
                            label.textContent =
                                adtypeCounters[val] > 0
                                    ? `${labelVal} (${adtypeCounters[val]})`
                                    : labelVal;
                            allCount += adtypeCounters[val];
                        }
                    }
                }
            });
            const allTypesEl = Array.from(adtypeLabels).filter(
                item => item.getAttribute('for') === 'all'
            );
            if (allTypesEl.length === 1) {
                const label = allTypesEl[0];
                const labelVal = label.getAttribute('data-adtypes-label-value');
                label.textContent =
                    allCount > 0
                        ? `${label.getAttribute(
                              'data-adtypes-label-value'
                          )} (${allCount})`
                        : labelVal;
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/myAdsFilter.js